import { useState } from 'react';
import { TicketConversationDialog } from '@/modules/simulator/conversations/past-ticket';
import { DrilldownPanel, type DrilldownView } from './drilldown-panel';
import { markedTicketColumn, TICKET_DRILLDOWN_COLUMNS } from './ticket-columns';

interface TicketDrilldownProps {
  view: DrilldownView | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  fromDate: string;
  toDate: string;
  overrideAccountId?: number;
}

/** The tickets behind a number in the drill-down panel; a row opens the ticket's conversation. */
export function TicketDrilldown({ view, overrideAccountId, ...panel }: TicketDrilldownProps) {
  const [openTicketId, setOpenTicketId] = useState<string | null>(null);

  return (
    <>
      <DrilldownPanel
        {...panel}
        view={view}
        columns={TICKET_DRILLDOWN_COLUMNS}
        noun='tickets'
        overrideAccountId={overrideAccountId}
        markedColumnId={(view && markedTicketColumn(view.request)) ?? undefined}
        // The thread API reads the signed-in account only, so another account's tickets do not open.
        onOpenRow={overrideAccountId === undefined ? (ticket) => setOpenTicketId(ticket.externalId) : undefined}
        canOpenRow={(ticket) => ticket.externalId !== null}
      />
      <TicketConversationDialog
        ticketId={openTicketId}
        onOpenChange={(open) => (open ? undefined : setOpenTicketId(null))}
        className='sm:max-w-3xl'
      />
    </>
  );
}
